<template>
    <footer>
        <div class="footerlogos">
            <div class="footerlogo-left">
                <a href="https://www.chi-athenaeum.org/" target="_blank"
                    ><img src="/images/TCA-LOGOTYPE.png"
                /></a>
                <div class="footercontact">
                    601 South Prospect Street, Galena, Illinois 61036, USA<BR />
                    <strong>Tel:</strong> +1 815 777 4444
                    <strong>E-mail:</strong> curatorial@chicagoathenaeum.org
                    <BR />
                    <a href="https://www.chi-athenaeum.org/" target="_blank"
                        >chicagoathenaeum.org</a
                    >
                    |
                    <a
                        href="https://www.metropolitanartspress.com"
                        target="_blank"
                        >metropolitanartspress.com</a
                    >
                    |
                    <a
                        href="https://www.instagram.com/thechicagoathenaeummuseum/"
                        target="_blank"
                        >Instagram</a
                    >
                    |
                    <a
                        href="https://www.facebook.com/TheChicagoAthenaeumMuseum?ref=hlm"
                        target="_blank"
                        >Facebook</a
                    >
                    |
                    <a
                        href="https://www.youtube.com/@thechicagoathenaeummuseum"
                        target="_blank"
                        >Youtube</a
                    >
                </div>
            </div>
            <div class="footerlogo-right">
                <slot></slot>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    name: "Footer",
    methods: {},
    mounted() {},
    computed: {},
};
</script>
